/**
 * @desc  登出时移除用户信息
 * @param {Object} wait - 登入登出时传入
 * 异步调用mutation中的方法，使用方法：this.$store.dispatch('方法名',value)
 * 自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
 */

export const SET_USERS_INFO = (context, userInfo) => {
  context.commit('SET_USER_INFO', userInfo)
}
export const REMOTE_USERS_INFO = (context) => {
  context.commit("REMOTE_USER_INFO")
}
export const SET_TOKEN = (context,token) => {
  context.commit("SET_TOKENS", token)
}
export const REMOVE_TOKEN = (context,token) => {
  context.commit("REMOVE_TOKENS")
}


// WEBPACK FOOTER //
// ./src/store/actions.js